const form = document.getElementById('site-search-form');

if (form) {
  form.addEventListener('submit', () => {
    const typed = form.q.value;
    form.q.value = `site:${form.dataset.searchHost} ${typed}`;
    // Form data is serialized synchronously right after this handler returns, before the
    // next tick — the timeout only restores what the user sees, not what gets submitted.
    setTimeout(() => {
      form.q.value = typed;
    });
  });
}
